module.exports = __webpack_public_path__ + "static/media/pic-man.8c879127.jpg";